module.exports = __webpack_public_path__ + "assets/89889688147bd7575d6327160d64e760.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
 ** module id = 1759
 ** module chunks = 1
 **/